namespace RioERP.Reports {
    export interface B2CStatewiseGstReportSummaryRow {
        Id?: number;
        BillingStateId?: number;
        StateName?: string;
        OrderMonth?: Web.Enums.EMonths;
        OrderYear?: Web.Enums.EYears;
        TaxCategoryId?: number;
        Taxcategory?: string;
        TotalTaxableAmount?: number;
        TotalTaxAmount?: number;
        CgstAmount?: number;
        SgstAmount?: number;
        IgstAmount?: number;
        TotalTax?: number;
    }

    export namespace B2CStatewiseGstReportSummaryRow {
        export const idProperty = 'Id';
        export const nameProperty = 'StateName';
        export const localTextPrefix = 'Reports.B2CStatewiseGstReportSummary';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            BillingStateId = "BillingStateId",
            StateName = "StateName",
            OrderMonth = "OrderMonth",
            OrderYear = "OrderYear",
            TaxCategoryId = "TaxCategoryId",
            Taxcategory = "Taxcategory",
            TotalTaxableAmount = "TotalTaxableAmount",
            TotalTaxAmount = "TotalTaxAmount",
            CgstAmount = "CgstAmount",
            SgstAmount = "SgstAmount",
            IgstAmount = "IgstAmount",
            TotalTax = "TotalTax"
        }
    }
}
